import { cva } from 'class-variance-authority';

export const cvaRoot = cva(['ProductRatingStyles-cvaRoot', '']);

export const cvaHeader = cva(['ProductRatingStyles-cvaHeader', 'flex gap-3.6', 'mb-3.2']);

export const cvaHeaderValue = cva(['ProductRatingStyles-cvaHeaderValue', 'text-h1 text-cBlack font-secondary']);

export const cvaStars = cva(['ProductRatingStyles-cvaStars', 'mb-0.4']);

export const cvaHeaderCount = cva(['ProductRatingStyles-cvaHeaderCount', 'text-bodyM text-cBlack48']);

export const cvaLines = cva(['ProductRatingStyles-cvaLines', 'max-w-[32.1rem]', 'mb-3.2']);

export const cvaLineWrap = cva(['ProductRatingStyles-cvaLine', 'flex items-center flex-1', 'not-last:mb-0.4']);

export const cvaLineTextLeft = cva(['ProductRatingStyles-cvaLineText', 'w-2', 'text-bodyS']);

export const cvaLine = cva([
  'ProductRatingStyles-cvaLine',
  'relative overflow-hidden',
  'flex-1',
  'mr-1.2',
  'h-0.6',
  'bg-cBlack16',
  'rounded-[1rem]',
]);

export const cvaLineFill = cva([
  'ProductRatingStyles-cvaLineFill',
  'block',
  'h-0.6',
  'bg-cMediumGreen',
  'rounded-[1rem]',
]);

export const cvaLineTextRight = cva(['ProductRatingStyles-cvaLineTextRight', 'text-bodyS text-cBlack64']);

export const cvaButton = cva(['ProductRatingStyles-cvaButton', 'py-1.4 pb-1.8 px-3.2', 'mb-1.6']);

export const cvaBottomText = cva(['ProductRatingStyles-cvaBottomText', 'max-w-[25.2rem]', 'text-bodyS text-cBlack64']);
